import React from "react";
import { Box } from "@chakra-ui/react";
import FormModal from "../Common/FormModal";

const DeleteSupplier = ({ isOpen, setIsOpen, supplier, action }) => {
  const handleSubmit = () => {
    action(supplier);
    setIsOpen(false);
  };

  return (
    <FormModal
      title={"Eliminar proveedor"}
      action={() => handleSubmit()}
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      isSubmitting={false}
      actionButton="Borrar"
    >
      <Box w="100%" mr="1">
        {`¿Desea borrar el proveedor ${supplier.businessName}?`}
      </Box>
    </FormModal>
  );
};

export default DeleteSupplier;
